"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7878],{

/***/ 80087:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ core_Carousel; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./components/indicator/index.ts + 2 modules
var indicator = __webpack_require__(81049);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/js/index.js
var js = __webpack_require__(10615);
// EXTERNAL MODULE: ./node_modules/react-responsive-carousel/lib/styles/carousel.css
var carousel = __webpack_require__(75472);
;// CONCATENATED MODULE: ./components/core/Carousel/Carousel.tsx






const imagesReducer = (images)=>{
    const imagesArr = [];
    if (images && images.length) {
        images.forEach((el)=>{
            const object = el;
            const key = Object.keys(el)[1];
            imagesArr.push(object[key]);
        });
        return imagesArr;
    }
    return;
};
const DEFAULT_CENTER_SLIDE_PERCENTAGE = 80;
const Carousel = (param)=>{
    let { images , imgClassName , children , centerMode , onSwipe , onChange , centerSlidePercentage , infinite =true  } = param;
    const imagesArr = imagesReducer(images);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(js/* Carousel */.lr, {
        onChange: onChange,
        onSwipeMove: onSwipe,
        showIndicators: true,
        showArrows: false,
        showStatus: false,
        swipeable: true,
        emulateTouch: true,
        preventMovementUntilSwipeScrollTolerance: true,
        swipeScrollTolerance: 50,
        infiniteLoop: infinite,
        showThumbs: false,
        autoPlay: false,
        centerMode: centerMode,
        centerSlidePercentage: centerSlidePercentage || DEFAULT_CENTER_SLIDE_PERCENTAGE,
        renderIndicator: (onClickHandler, isSelected, index, label)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(indicator/* default */.Z, {
                onClickHandler: onClickHandler,
                isSelected: isSelected,
                index: index,
                label: label
            });
        },
        children: (imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.map((item, index)=>{
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                ...(0,imageSerializer/* imageSerializer */.l)(item),
                className: imgClassName
            }, index);
        })) || children
    });
};

;// CONCATENATED MODULE: ./components/core/Carousel/index.ts

/* harmony default export */ var core_Carousel = (Carousel);


/***/ }),

/***/ 81049:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ indicator; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./common/consts/theme.ts
var theme = __webpack_require__(22004);
;// CONCATENATED MODULE: ./components/indicator/indicator.styles.tsx

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n    "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}



const Item = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("li", {
    target: "eanor9r0"
})("position:relative;width:0.75rem;height:0.75rem;border:0.0625rem solid ", (param)=>{
    let { theme  } = param;
    return theme.colors.primary;
}, ";border-radius:50%;background:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";overflow:hidden;margin:0 1.375rem 0 0;");
const RadioButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "eanor9r1"
})("position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);overflow:hidden;width:0.5rem;height:0.5rem;border-radius:50%;background-color:", (param)=>{
    let { theme  } = param;
    return theme.colors.core_white;
}, ";", (param)=>{
    let { isSelected  } = param;
    return isSelected && (0,emotion_react_browser_esm/* css */.iv)(_templateObject(), theme/* THEME.colors.primary */.C.colors.primary);
}, ";");

;// CONCATENATED MODULE: ./components/indicator/Indicator.tsx


const Indicator = (param)=>{
    let { onClickHandler , isSelected , index , label  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Item, {
        onClick: onClickHandler,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RadioButton, {
            isSelected: isSelected
        })
    });
};


;// CONCATENATED MODULE: ./components/indicator/index.ts

/* harmony default export */ var indicator = (Indicator);


/***/ }),

/***/ 9368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TrustedBy; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
// EXTERNAL MODULE: ./styles/mixins.ts
var mixins = __webpack_require__(8066);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(70917);
// EXTERNAL MODULE: ./components/core/Typography/Typography.tsx
var Typography = __webpack_require__(44718);
// EXTERNAL MODULE: ./components/core/Carousel/index.ts + 1 modules
var core_Carousel = __webpack_require__(80087);
;// CONCATENATED MODULE: ./components/sections/TrustedBy/trustedBy.styles.ts

function _templateObject() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    padding-top: 2.625rem;\n    row-gap: 2.75rem;\n    padding-bottom: 0.813rem;\n  "
    ]);
    _templateObject = function() {
        return data;
    };
    return data;
}
function _templateObject1() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    margin-bottom: 1.5rem;\n  "
    ]);
    _templateObject1 = function() {
        return data;
    };
    return data;
}
function _templateObject2() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 3.5rem;\n    width: 9rem;\n  "
    ]);
    _templateObject2 = function() {
        return data;
    };
    return data;
}
function _templateObject3() {
    const data = (0,_tagged_template_literal/* default */.Z)([
        "\n    height: 4.625rem;\n    width: 12.25rem;\n  "
    ]);
    _templateObject3 = function() {
        return data;
    };
    return data;
}





const Section = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("section", {
    target: "e1bnk0jk0"
})(mixins/* defaultContainerSize */.sX, ";display:flex;flex-wrap:wrap;z-index:0;position:relative;padding-top:1.813rem;padding-bottom:1.25rem;row-gap:1rem;", mixins.mq.medium((0,emotion_react_browser_esm/* css */.iv)(_templateObject())));
const InnerWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bnk0jk1"
})("display:flex;flex-direction:column;align-items:center;width:100%;");
const Subtitle = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("p", {
    target: "e1bnk0jk2"
})(Typography/* ParagraphM */.Sl, ";align-self:center;color:", (param)=>{
    let { theme  } = param;
    return theme.colors.darker_grey;
}, ";margin:0rem 0 1rem 0;text-align:center;width:100%;", mixins.mq.large((0,emotion_react_browser_esm/* css */.iv)(_templateObject1())));
const Company = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1bnk0jk3"
})("position:relative;height:2.625rem;width:6.875rem;", mixins.mq.small((0,emotion_react_browser_esm/* css */.iv)(_templateObject2())), " ", mixins.mq.xLarge((0,emotion_react_browser_esm/* css */.iv)(_templateObject3())));
const CarouselWrapper = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled("div", {
    target: "e1bnk0jk4"
})("display:block;width:12.25rem;height:4.625rem;overflow:visible;")));
const StyledCarousel = /*#__PURE__*/ (/* unused pure expression or super */ null && (styled(Carousel, {
    target: "e1bnk0jk5"
})("width:12.25rem;height:4.625rem;overflow:visible;")));

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./utils/imageSerializer.ts
var imageSerializer = __webpack_require__(9790);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 194 modules
var motion = __webpack_require__(96121);
;// CONCATENATED MODULE: ./components/core/InfiniteSliderFramer/infiniteSliderFramer.styles.tsx


const StyledContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1i6w63s0"
})("width:100%;overflow:hidden;");
const StyledMotionWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(motion/* motion.div */.E.div, {
    shouldForwardProp: (propName)=>!propName.startsWith("$"),
    target: "e1i6w63s1"
})("display:flex;width:", (param)=>{
    let { $calculatedWidth  } = param;
    return $calculatedWidth ? "".concat($calculatedWidth, "rem") : "100%";
}, ";");
const StyledImageWrapper = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("div", {
    target: "e1i6w63s2"
})("margin-right:", (param)=>{
    let { $gap  } = param;
    return $gap ? "".concat($gap, "rem") : "1rem";
}, ";align-self:center;");

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/core/InfiniteSliderFramer/infiniteSliderFramer.hooks.tsx

const useInfiniteSliderFramer = (param)=>{
    let { slides , slideWidthInRem , gap , speed  } = param;
    const imagesReducer = (0,react.useCallback)((images)=>{
        const imagesArr = [];
        if (images && (images === null || images === void 0 ? void 0 : images.length)) {
            images.forEach((el)=>{
                var _Object_keys, _Object_keys_call;
                const object = el;
                const key = Object === null || Object === void 0 ? void 0 : (_Object_keys = Object.keys) === null || _Object_keys === void 0 ? void 0 : (_Object_keys_call = _Object_keys.call(Object, el)) === null || _Object_keys_call === void 0 ? void 0 : _Object_keys_call[1];
                imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.push(object === null || object === void 0 ? void 0 : object[key]);
            });
            return imagesArr;
        }
        return [];
    }, []);
    const imagesArr = (0,react.useMemo)(()=>{
        if (slides) {
            const duplicatedSlides = [
                ...slides,
                ...slides
            ];
            return imagesReducer(duplicatedSlides);
        } else {
            return [];
        }
    }, [
        slides
    ]);
    const duration = (0,react.useMemo)(()=>{
        return (slides === null || slides === void 0 ? void 0 : slides.length) ? speed * (slides === null || slides === void 0 ? void 0 : slides.length) : 1;
    }, [
        slides
    ]);
    const totalAnimationDistance = (0,react.useMemo)(()=>{
        return (slides === null || slides === void 0 ? void 0 : slides.length) ? -((slideWidthInRem + gap) * (slides === null || slides === void 0 ? void 0 : slides.length) * 16) : 0;
    }, [
        slides,
        slideWidthInRem
    ]);
    return {
        imagesArr,
        duration,
        totalAnimationDistance
    };
};

;// CONCATENATED MODULE: ./components/core/InfiniteSliderFramer/InfiniteSliderFramer.tsx





const InfiniteSliderFramer = (param)=>{
    let { slides , slideWidthInRem , gap =1.5 , speed =4  } = param;
    const { imagesArr , duration , totalAnimationDistance  } = useInfiniteSliderFramer({
        slides,
        slideWidthInRem,
        gap,
        speed
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: (slides === null || slides === void 0 ? void 0 : slides.length) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledContainer, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledMotionWrapper, {
                initial: {
                    x: 0
                },
                animate: {
                    x: totalAnimationDistance
                },
                transition: {
                    x: {
                        repeat: Infinity,
                        duration: duration,
                        ease: "linear"
                    }
                },
                $calculatedWidth: (slideWidthInRem + gap) * (imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.length),
                children: imagesArr === null || imagesArr === void 0 ? void 0 : imagesArr.map((slide, index)=>/*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledImageWrapper, {
                        $gap: gap,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((image_default()), {
                            ...(0,imageSerializer/* imageSerializer */.l)(slide)
                        })
                    }, index))
            })
        })
    });
};

;// CONCATENATED MODULE: ./components/core/InfiniteSliderFramer/index.ts

/* harmony default export */ var core_InfiniteSliderFramer = (InfiniteSliderFramer);

;// CONCATENATED MODULE: ./components/sections/TrustedBy/TrustedBy.tsx



const TrustedBy = (param)=>{
    let { companiesTitle , companies  } = param;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Section, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InnerWrapper, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Subtitle, {
                    children: companiesTitle
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(core_InfiniteSliderFramer, {
                    slides: companies,
                    slideWidthInRem: 12.25
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./components/sections/TrustedBy/index.ts

/* harmony default export */ var sections_TrustedBy = (TrustedBy);


/***/ })

}]);